import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 导入 modules 路由文件
const context = require.context('./modules', true, /\.js$/), routersList = [];

context.keys().forEach(item => {
  const component = context(item).default;
  if (Array.isArray(component))
  {
    component.forEach(router => {
      routersList.push(router)
    })
  }
});

const routes = [
  ...routersList
]

const router = new VueRouter({
  routes
})

// //路由守卫 判断是否从新登录
// router.beforeEach((to, from, next) => {
//   let token = localStorage.getItem('token')
//   window.console.log(token)
//   if (token) {
//       if (to.path == '/login') {
//           next('/')
//       } else {
//           next()
//       }
//   } else if (to.path == '/login') {
//       next()
//   } else {
//       next('/login')
//   }
// })

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
